import { getSystemIcon, SystemIcon } from '@helpers/icons';
import { imageUrl } from '@helpers/image';
import { FakeButton } from '@stories/Components/Buttons/Button/Button';
import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import * as React from 'react';
import S from './UspCard.styles';
const UspCard = (props) => {
    return (React.createElement(S.Container, { "data-type": props.type, "data-align": props.alignment, ...(props.cta ? { as: 'a', href: props.cta.url, target: props.cta.target } : {}) },
        props.image || (props.icon && props.icon !== SystemIcon.None) ? (React.createElement(S.ImageWrapper, null, props.image ? (React.createElement(S.Image, { src: imageUrl(props.image, { width: 140, height: 140 }), alt: props.image.altText, loading: "lazy" })) : props.icon ? (React.createElement(S.Icon, null, getSystemIcon(props.icon))) : null)) : null,
        React.createElement(S.Title, null, props.title),
        props.description ? React.createElement(S.Description, null, props.description) : null,
        props.cta ? (React.createElement(FakeButton, { buttonType: props.type === ContentType.Intermediaries
                ? 'intermediaries-secondary'
                : props.type === ContentType.Savings
                    ? 'savings'
                    : 'default' }, props.cta.text)) : null));
};
export default UspCard;
